



import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class PageAlert extends Vue {
  @Prop({ required: false, type: Boolean }) isLoading !: boolean
  @Prop({ required: false, type: String }) message !: string
  @Prop({ required: false, type: Array, default: [] }) errors !: []

  private get isShowError(): boolean {
    return !!this.errors.length;
  }

  private get isShowMessage(): boolean {
    return !!(this.message && !this.isShowError);
  }
}
